const PageCrash = () => (
	<section className="min-h-screen flex items-center justify-center bg-bg-page text-center px-6">
		<div>
			<h1 className="text-heading-lg font-bold text-text-primary mb-4">Something went wrong</h1>
			<p className="text-text-secondary mb-6">This page failed to load.</p>
			<a href="/" className="px-6 py-3 rounded-component bg-brand-primary text-brand-text">
				Go home
			</a>
		</div>
	</section>
)

export default PageCrash
